import { render, staticRenderFns } from "./changeCardConfig.vue?vue&type=template&id=d9c1b10c&scoped=true&"
import script from "./changeCardConfig.vue?vue&type=script&lang=js&"
export * from "./changeCardConfig.vue?vue&type=script&lang=js&"
import style0 from "./changeCardConfig.vue?vue&type=style&index=0&id=d9c1b10c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c1b10c",
  null
  
)

export default component.exports